export default "__VITE_ASSET__D19C2ggu__"